/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.listRecords'

export { $nsid }

/** List a range of records in a repository, matching a specific collection. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    repo: l.string({ format: 'at-identifier' }),
    collection: l.string({ format: 'nsid' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    reverse: l.optional(l.boolean()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    records: l.array(l.ref<Record$0>((() => record$0) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Record$0 = {
  $type?: 'com.atproto.repo.listRecords#record'
  uri: l.AtUriString
  cid: l.CidString
  value: l.LexMap
}

export type { Record$0 as Record }

const record$0 = l.typedObject<Record$0>(
  $nsid,
  'record',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    value: l.lexMap(),
  }),
)

export { record$0 as record }
